export default __webpack_public_path__ + "static/media/débito.2f84c045.png";